import { useState } from "react";
import MoreInfo from "./modals/MoreInfoModal";

const OnlineCourse = ({ onlineData, lesson }) => {
  const [popupData, setPopupData] = useState(null);

  const openPopup = (lesson) => {
    setPopupData(lesson);
  };

  return (
    <>
      <section className="inner-course-detail new-driver-blog new-driver-section section-padding">
        <div className="container">
          <div className="row">
            {onlineData && (
              <div
                dangerouslySetInnerHTML={{ __html: onlineData.heading }}
              ></div>
            )}
            <div className="new-drivers-course">
              {/* main map */}
              {lesson &&
                lesson.map((lessonData, index) => {
                  return (
                    <div
                      key={index}
                      className="d-flex justify-content-between flex-column course-detail-blog new-driver-box-blog"
                      style={{
                        backgroundColor: lessonData.best_seller
                          ? "green"
                          : "white",
                      }}
                    >
                      {lessonData.best_seller === 1 && (
                        <p className="best-new-badge">
                          <span className="best-seller-badge badge">
                            Best Seller
                          </span>
                        </p>
                      )}
                      <div className="text-center">
                        <img
                          src={lessonData.icon_url}
                          alt=""
                          className="mb-md-3 mb-2"
                        />
                        <h5
                          style={{
                            color: lessonData.best_seller ? "white" : "black",
                          }}
                          className="course-detail-heading text-capitalize mb-md-3 mb-2"
                        >
                          {lessonData.name}
                          <div />
                        </h5>
                        <p
                          style={{
                            color: lessonData.best_seller ? "white" : "black",
                          }}
                        >
                          {lessonData.short_description}
                        </p>
                      </div>
                      <div className="detail-btn d-flex align-items-center justify-content-space-between flex-column">
                        <div
                          style={{
                            color: lessonData.best_seller ? "white" : "black",
                          }}
                          className="price mb-md-4 mb-3"
                        >
                          ${lessonData.price}
                        </div>
                        {lessonData.additional_text && (
                          <div
                            style={{
                              color: lessonData.best_seller ? "white" : "black",
                            }}
                            className="price save-offer mb-md-4 mb-3"
                          >
                            {lessonData.additional_text}
                          </div>
                        )}
                        {/* Button trigger modal */}
                        {lessonData.long_description ? (
                          <a
                            onClick={() => openPopup(lessonData)}
                            className="btn small-btn d-flex align-items-center justify-content-center"
                            data-bs-toggle="modal"
                            data-bs-target="#more-info"
                          >
                            Get Started
                            <i className="fa-solid fa-circle-chevron-right"></i>
                          </a>
                        ) : (
                          <a href={lessonData.register_url}  target="_blank" rel="noreferrer" className="btn small-btn d-flex align-items-center justify-content-center">
                            Get Started
                            <i className="fa-solid fa-circle-chevron-right"></i>
                          </a>
                        )}
                      </div>
                    </div>
                  );
                })}
              <MoreInfo lessonData={popupData} />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default OnlineCourse;
